 var swiper = new Swiper(".custom-review-slider", {
  slidesPerView: 4,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-paginationn',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-nextt',
    prevEl: '.swiper-button-prevv',
  },
  breakpoints: {
    0: {
      slidesPerView: 1.40,
      spaceBetween: 20
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});